import styled from "@emotion/styled";
import { Dialog } from "@mui/material";
const StyledProfile = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledProfileInfo = styled.div`
  .basic-info {
    display: flex;
    flex-direction: row;
    flex-grow: 4;
    align-items: center;
    color: var(--cms-text-secondary);
    font-size: 15px;
    line-height: 16px;
    > div {
      margin-right: 15px;
    }
  }
`;

const StyledProfilePasswordReset = styled.div`
  width: 600px;
  form {
    display: flex;
    flex-direction: column;
  }
  .MuiCardActions-root {
    margin: 20px 0 0 0;
  }
  .info {
    font-size: 12px;
    ul {
      margin: 0;
      padding: 24px 0 0 22px;
      color: #b91c1c;
    }
  }
`;

const StyledProfileImageDialog = styled(Dialog)`
  display: flex;
`;

export {
  StyledProfile,
  StyledProfileInfo,
  StyledProfileImageDialog,
  StyledProfilePasswordReset,
};
